import {printoutPalette} from "./printoutPalette";
import {printoutTheme, printoutTypeSx} from "./printoutTheme";

// Shared by the editor canvas and document renderer.
export const PRINTOUT_BASE_FONT_SIZE = printoutTheme.type.body1.fontSize;
export const PRINTOUT_BASE_LINE_HEIGHT = printoutTheme.type.body1.lineHeight;
export const PRINTOUT_NORMAL_TEXT_MEASURE = printoutTheme.measure;

export const printoutDocumentTypographySx = {
    color: printoutPalette.secondaryText,
    ...printoutTypeSx(printoutTheme.type.body1),
    "& h1, & h2, & h3, & h4": {
        color: printoutPalette.primaryText,
        fontFamily: "var(--printout-heading-font-family)",
    },
    "& h1": {
        ...printoutTypeSx(printoutTheme.type.h1),
        margin: "0 0 4mm",
    },
    "& h2": {
        ...printoutTypeSx(printoutTheme.type.h2),
        margin: "8mm 0 4mm",
    },
    "& h3": {
        ...printoutTypeSx(printoutTheme.type.h3),
        margin: "8mm 0 2mm",
    },
    "& h4": {
        ...printoutTypeSx(printoutTheme.type.h4),
        margin: "8mm 0 2mm",
    },
    "& p, & li": {
        color: "inherit",
        maxWidth: `${printoutTheme.measure}ch`,
    },
    "& p": {
        margin: "0 0 4mm",
    },
    "& li": {
        margin: "0 0 4px",
    },
    '& p[data-printout-paragraph-variant="body2"]': {
        color: printoutPalette.mutedText,
        ...printoutTypeSx(printoutTheme.type.body2),
        marginBottom: "2mm",
    },
    '& p[data-printout-paragraph-variant="caption"]': {
        color: printoutPalette.mutedText,
        ...printoutTypeSx(printoutTheme.type.caption),
        marginBottom: "2mm",
    },
    '& p[data-printout-paragraph-variant="displayTitle"]': {
        ...printoutTypeSx(printoutTheme.type.displayTitle),
        color: printoutPalette.primaryText,
        fontFamily: "var(--printout-heading-font-family)",
        marginBottom: "4mm",
        maxWidth: "none",
    },
    '& p[data-printout-paragraph-variant="largeValue"]': {
        ...printoutTypeSx(printoutTheme.type.largeValue),
        color: printoutPalette.primaryText,
        fontVariantNumeric: "tabular-nums",
        marginBottom: "4mm",
        maxWidth: "none",
    },
    '& p[data-printout-paragraph-variant="detailValue"]': {
        ...printoutTypeSx(printoutTheme.type.detailValue),
        color: printoutPalette.primaryText,
        fontVariantNumeric: "tabular-nums",
        marginBottom: "2mm",
    },
    "& strong, & b": {
        color: printoutPalette.primaryText,
    },
    "& blockquote": {
        borderLeft: `3px solid ${printoutPalette.border}`,
        color: printoutPalette.secondaryText,
        margin: "14px 0",
        maxWidth: `${printoutTheme.measure}ch`,
        padding: "2px 0 2px 14px",
    },
    "& blockquote p": {
        maxWidth: "none",
    },
    '& blockquote p[data-printout-paragraph-variant="body2"], & blockquote p[data-printout-paragraph-variant="caption"]': {
        color: "inherit",
    },
    "& code": {
        backgroundColor: printoutPalette.subtleFill,
        border: `1px solid ${printoutPalette.subtleBorder}`,
        borderRadius: "4px",
        color: printoutPalette.primaryText,
        fontFamily: '"SFMono-Regular", Consolas, "Liberation Mono", monospace',
        fontSize: "0.92em",
        padding: "0.08em 0.32em",
        whiteSpace: "break-spaces",
    },
    // Footer dividers pin themselves and the following content to the page bottom.
    [[
        '&:has(> .printout-block-shell[data-printout-divider-role="footer"])',
        '&:has(> .printout-rendered-divider-block[data-printout-divider-role="footer"])',
    ].join(", ")]: {
        display: "flex",
        flexDirection: "column",
    },
    [[
        '& > .printout-block-shell[data-printout-divider-role="footer"]',
        '& > .printout-rendered-divider-block[data-printout-divider-role="footer"]',
    ].join(", ")]: {
        mt: "auto",
    },
    '& p[style*="text-align: center"], & p[style*="text-align: right"], & p[style*="text-align: justify"]': {
        maxWidth: "none",
    },
};
